import { Helper } from '@/mixin/helper'
import store from '@/state/store'
const hasAccess = store.getters['identity/hasAccess']

export default [
  {
    path: '/company-ticket/',
    name: 'Company Ticket',
    meta: {
      authRequired: true,
      hasAccess: true,
      beforeResolve(_, routeFrom, next) {
        const acc = hasAccess([
          'company_ticket:read',
        ])
        if (!acc) return next({ name: 'Liveview' })

        Helper.methods.userLogging('Access', _)
        next()
      },
    },
    component: () =>
      import(
        /* webpackChunkName: "master" */ '@/router/views/company-ticket/TicketLists'
      ),
  },
]
